import React, { useState } from "react";
import { Dropdown, Spinner } from "react-bootstrap";
import { exportElementToPdf } from "../utils/pdfExportUtils";
import {
  downloadAvailabilityXlsx,
  getAvailabilityExportPayload,
  hasAvailabilityExportData,
} from "../utils/availabilityExportUtils";

const AvailabilityExportButton = ({
  tableRef,
  viewMode = "hotels",
  hotels = [],
  roomPlans = [],
  days = [],
  filename = "resort-availability",
  disabled = false,
}) => {
  const [exporting, setExporting] = useState(false);
  const [exportType, setExportType] = useState("");

  const timestamp = new Date().toISOString().slice(0, 10);
  const exportFilename = `${filename}-${timestamp}`;
  const canExport = hasAvailabilityExportData({ viewMode, hotels, roomPlans });
  const isDisabled = disabled || exporting || !canExport || !days.length;

  const handlePdfExport = async () => {
    if (!tableRef?.current) {
      alert("Table not ready for export.");
      return;
    }

    if (!canExport) {
      alert("No availability data to export.");
      return;
    }

    setExporting(true);
    setExportType("pdf");

    try {
      await exportElementToPdf(tableRef.current, exportFilename);
    } catch (error) {
      console.error("PDF export error:", error);
      alert("Failed to export PDF. Please try again.");
    } finally {
      setExporting(false);
      setExportType("");
    }
  };

  const handleExcelExport = () => {
    if (!canExport) {
      alert("No availability data to export.");
      return;
    }

    setExporting(true);
    setExportType("excel");

    try {
      const payload = getAvailabilityExportPayload({
        viewMode,
        hotels,
        roomPlans,
        days,
      });
      downloadAvailabilityXlsx({ ...payload, filename: exportFilename });
    } catch (error) {
      console.error("Excel export error:", error);
      alert("Failed to export Excel file. Please try again.");
    } finally {
      setExporting(false);
      setExportType("");
    }
  };

  return (
    <Dropdown align="end">
      <Dropdown.Toggle
        variant="secondary"
        disabled={isDisabled}
        id="availability-export-dropdown"
      >
        {exporting ? (
          <>
            <Spinner size="sm" animation="border" className="me-2" />
            Exporting {exportType === "pdf" ? "PDF" : "Excel"}...
          </>
        ) : (
          <>
            <i className="fa-solid fa-download me-2" />
            Export
          </>
        )}
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <Dropdown.Item onClick={handlePdfExport} disabled={exporting}>
          <i className="fa-solid fa-file-pdf me-2" />
          Export as PDF
        </Dropdown.Item>
        <Dropdown.Item onClick={handleExcelExport} disabled={exporting}>
          <i className="fa-solid fa-file-excel me-2" />
          Export as Excel
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default AvailabilityExportButton;
